export default __webpack_public_path__ + "static/media/TURN.bab7e896.wav";